import axiosInstance from '@/lib/axios';
import { endpoints } from './endpoints';
import type { Field, FieldSet, Localisation } from './types';

export async function getLocalisation(): Promise<Localisation> {
  const response = await axiosInstance.get<Localisation>(endpoints.localisation.base);
  return response.data;
}

export async function getFieldsByFieldSet(
  fieldSetName: string,
  eventId?: string,
): Promise<Field[]> {
  const response = await axiosInstance.get<Field[]>(
    endpoints.localisation.fieldsByFieldSet(fieldSetName, eventId),
  );
  return response.data;
}

export async function getPodsByFieldSet(
  fieldSetName: string,
  eventId?: string,
): Promise<FieldSet[]> {
  const response = await axiosInstance.get<FieldSet[]>(
    endpoints.localisation.podsByFieldSet(fieldSetName, eventId),
  );
  return response.data;
}
